import React, { useEffect, useRef, useState } from 'react';
import { PrintOutlined } from '@mui/icons-material';
import { Box, Button, Container, Typography, TextField, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { Template1, Template2, Template3, Template4 } from './QRTemplates';
import { callPostApi } from '../../API/ApiCallFunction';
import GradientLoader from '../../CommanComponents/GradientLoader';

export default function PrintQRPlus() {
  const qrRef = useRef();
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem('user') || '{}');
   const [loading, setLoading] = useState(false);
   const [templateIndex, setTemplateIndex] = useState(0);
   const templates = [Template1, Template2, Template3, Template4];
   const [datar, setDatar] = useState([]);
   const [filterStatus, setFilterStatus] = useState('Pending');
   const [filterLotNo, setFilterLotNo] = useState('');
   const [filterLoadedNo, setFilterLoadedNo] = useState('');
   const [filterLimit, setFilterLimit] = useState(100);
   
  const clearFun = async () => {
    const newStatus = 'Pending';
    const newLotNo = "";
    const newLoadedNo = "";
    const newlimit = 100;
    setFilterStatus(newStatus);
    setFilterLimit(newlimit);
    setFilterLotNo(newLotNo);
    setFilterLoadedNo(newLoadedNo)
    await prnitQRListApi(newStatus, newLotNo, newLoadedNo, newlimit);
  }
  
  const handleChangeTemplate = () => {
    setTemplateIndex((prev) => (prev + 1) % templates.length);
  };

  const CurrentTemplate = templates[templateIndex];

  const handlePrint = useReactToPrint({
    contentRef: qrRef, 
    documentTitle: 'QR Code',
    pageStyle: `
      @page { size: auto; margin: 20mm; }
      body {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        background: white !important;
        font-family: 'Roboto', sans-serif !important;
      }
      .MuiCard-root {
        page-break-inside: avoid;
      }
    `,
  });

  //Print api

   const prnitQRListApi= async (status,lotNo, loadedNo, limit) => {
        try {
          setLoading(true);
          const storeid = user.store_info.store_id;
          let qrstatus = "";
          if (status === "Pending") qrstatus = '0';
          else if (status === "Activated") qrstatus = '2';
          else if (status === "Loaded") qrstatus = '1';
    
          const payload = { mod: "CASHI_QECODE_LIST", data_arr: { store_id:storeid, genLotNumber:lotNo, loadingNumber:loadedNo,
                           qrcodeStatus:qrstatus, start: '0', limit:filterLimit,}, };
 
          const apiResult = await callPostApi("cashi-qrcode", payload);
          if (apiResult.status === "200" && Array.isArray(apiResult.data)) { 
           const formattedData = apiResult.data.filter((item) => item.redeem_status === "0").map((item, index) => ({
           id: index + 1,
           qr: item.qrcode_number || "NA",
           expdate: item.expiry_date || "NA",
           amount: item.amount || "NA",   
          }));
              setDatar(formattedData);
          } else {
           setDatar([]); 
          }
        } catch (err) { 
        } finally {
          setLoading(false);
        }
      }; 
  
   useEffect(() => {
     prnitQRListApi("Pending","","",100);
    }, []);



  return (
    <Box>
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
          <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}
            onClick={() => navigate(-1)}> Back
          </Button>
        </Box>

        <Typography variant="h6"  gutterBottom
          sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', p: 1, color: '#ffffff',
            borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center',}}>
          <PrintOutlined sx={{ mx: 1 }} /> Print QR Code
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
          <Button variant="contained" sx={{background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', color: '#ffffff',}}
           onClick={handleChangeTemplate}> Change Template </Button>
          <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
           onClick={handlePrint} > <PrintOutlined sx={{ mx: 1 }} /> Print </Button >
           <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #EC407A, #D81B60)', color: '#ffffff', ml:1}}
           onClick={()=> navigate('/dashboardPlus/qr')} > <PrintOutlined sx={{ mx: 1 }} /> QR </Button>
       </Box>
       
      {/* Filter section */}
      <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>
        <TextField select label="Status" value={filterStatus} onChange={e => { setFilterStatus(e.target.value); }} sx={{ minWidth: 140 }} >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Loaded">Loaded</MenuItem>
          <MenuItem value="Activated">Activated</MenuItem>
       </TextField>
       <TextField  label="Lot Number" value={filterLotNo} onChange={(e) => setFilterLotNo(e.target.value)} sx={{ minWidth: 160 }} />
       <TextField  label="Loaded Number" value={filterLoadedNo} onChange={(e) => setFilterLoadedNo(e.target.value)} sx={{ minWidth: 160 }} />
       <TextField select label="Limit" value={filterLimit} onChange={(e) => setFilterLimit(e.target.value)} sx={{ minWidth: 140 }} >
          <MenuItem value={100}>100</MenuItem>
          <MenuItem value={300}>300</MenuItem>
          <MenuItem value={500}>500</MenuItem>
          <MenuItem value={2000}>All</MenuItem>
       </TextField>
       <Button variant="outlined" color="primary" sx={{ height: 56 }} 
        onClick={() => { prnitQRListApi(filterStatus, filterLotNo,filterLoadedNo,filterLimit);}} > Apply Filter </Button>
       <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={() => {clearFun()}}> Clear Filter </Button>
      </Box>
      
      <Box ref={qrRef} sx={{ display: 'flex', flexWrap: 'wrap', border: '2px dashed #ccc', borderRadius: '8px', p: 2 }}>
        {datar.length > 0 ? ( datar.map((item, idx) => (
        <CurrentTemplate key={idx} user={user} qrno={item.qr} expdate={item.expdate} amount={item.amount} /> ))
          ) : ( <Typography sx={{ p: 3, color: '#888' }}>  No QR data available. </Typography> )}
      </Box>
    </Container>

       {loading && <GradientLoader text="Loading" />}        {/* // loader */}
  </Box>
  );
}
